import { createAction } from '@reduxjs/toolkit';

export const updateOpenedSections = createAction(
  'docsMenu/updateOpenedSections',
  (linkClicked: string) => {
    return {
      payload: {
        linkClicked,
      },
    };
  },
);
